<template>
    <AppLayout title="Users">
        <div>
            <div>
                <Link :href="route('users.manage')">
                    <v-btn text="Manage"></v-btn>
                </Link>
                <Link :href="route('users.manage', 1)">
                    <v-btn text="Update"></v-btn>
                </Link>
                <Link :href="route('users.manage', 2)">
                    <v-btn text="Update 2"></v-btn>
                </Link>
            </div>
            <v-table>
                <thead>
                <tr>
                    <th class="text-left">
                    Name
                    </th>
                    <th class="text-left">
                    Email
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="item in page.props.data.users"
                    :key="item.name"
                >
                    <td>{{ item.name }}</td>
                    <td>{{ item.email }}</td>
                </tr>
                </tbody>
            </v-table>
        </div>
    </AppLayout>
</template>
<script setup lang="ts">
    import { ref } from "vue";
    import { usePage, Link } from '@inertiajs/vue3';
    import AppLayout from '@/Layouts/AppLayout.vue';
    import { SharedPageProps } from '@/Types/inertia';
    import { User } from '@/Types/Models/user';

    interface PageData extends SharedPageProps{
        data:{
            users: User[];
        };
        title: string;
    }

    const page = usePage<PageData>()
    console.log(page.props)
</script>